import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCheckBadgeFill';
/** Renders an SVG icon. */
const SvgCheckBadgeFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.47 4.152c1.479-2.87 5.581-2.87 7.06 0a1.97 1.97 0 0 0 2.352.974c3.074-.983 5.975 1.918 4.992 4.992a1.97 1.97 0 0 0 .974 2.352c2.87 1.479 2.87 5.581 0 7.06a1.97 1.97 0 0 0-.974 2.352c.983 3.074-1.918 5.975-4.992 4.992a1.97 1.97 0 0 0-2.352.974c-1.479 2.87-5.581 2.87-7.06 0a1.97 1.97 0 0 0-2.352-.974c-3.074.983-5.975-1.918-4.992-4.992a1.97 1.97 0 0 0-.974-2.352c-2.87-1.479-2.87-5.581 0-7.06a1.97 1.97 0 0 0 .974-2.352c-.983-3.074 1.918-5.975 4.992-4.992a1.97 1.97 0 0 0 2.352-.974M22.2 12.9a1.5 1.5 0 1 0-2.4-1.8l-4.962 6.617-2.777-2.778a1.5 1.5 0 0 0-2.122 2.122l4 4a1.5 1.5 0 0 0 2.261-.16z"
      />
    </svg>
  );
};
SvgCheckBadgeFill.displayName = displayName;
export default SvgCheckBadgeFill;
